import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useContextProps } from 'react-aria-components';
import { Size } from '../../../../constants/size.js';
import { twMerge } from '../../../../utils/twMerge.js';
import { DescriptionListItemContext } from '../DescriptionListItem.js';
export const DescriptionDetails = forwardRef(function DescriptionDetails(props, forwardedRef) {
    const [{ column, size = Size.Default, ...ddProps }, ref] = useContextProps(props, forwardedRef, DescriptionListItemContext);
    return (_jsx("dd", { ...ddProps, ref: ref, className: twMerge('ppl-DescriptionDetails', 'w-full min-w-0 text-default', {
            default: 'text-body-md',
            loose: 'text-body-lg font-medium',
        }[size], ddProps.className) }));
});
//# sourceMappingURL=DescriptionDetails.js.map